<template>
  <div class="space-lottery game-table">
    <div class="game-table-title">
      <div class="row">
        <div class="col-xs-7">
          <h4>
            <i class="fa fa fa-cubes"></i>
            <span class="kind">{{ $t('games.space_lottery') }}</span>
            <!-- <span class="label label-info game-kind">{{ title }}</span> -->
          </h4>
        </div>
        <div class="col-xs-5 game-info text-right">
          <span v-if="title">
            {{ $t('messages.round') }} {{ title | roundOnly }}
          </span>
          <span v-else>{{ $t('messages.break') }}</span>
        </div>
      </div>
    </div>
    <a href="/games/auto-lotto" class="game-table-detail clearfix">
      <div class="game-table-cover">
      </div>
    </a>
    <!-- <div class="game-table-detail clearfix">
      <div class="game-table-preview dragscroll">
        <div class="game-table-panel" style="height:100%" :style="'min-width:' + autoWidth + 'px'">
          <div class="box-stat-wrapper" v-if="statistics['bigRoad'].length > 0">
          </div>
        </div>
      </div>
      <a class="game-table-img" :href="route">
        <span class="game-kind">{{ title }}</span>
        <img :src="image" width="100" height="100" key="image" v-if="image">
        <img src="//via.placeholder.com/100x100" key="image" v-else>
      </a>
    </div> -->
    <div class="game-table-sub clearfix">
      <div class="row">
        <div class="col-xs-6">
          <span>
            {{ $t('messages.remains', { time: formatTime(countdown) }) }}
          </span>
        </div>
        <div class="col-xs-6">
          <span style="float: right;">
            {{ $t('messages.spaceLottoLastedResult', { result: lastedResult ? lastedResult : '-' }) }}
          </span>
        </div>
        <!-- <div class="col-lg-6 col-xs-7 pull-right">
          <div class="box-winner">
            <div class="winner">
              <span>{{ winners.b }}</span>
              <i class="b"></i>
            </div>
            <div class="winner">
              <span>{{ winners.p }}</span>
              <i class="p"></i>
            </div>
            <div class="winner">
              <span>{{ winners.t }}</span>
              <i class="t"></i>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="game-table-bottom clearfix">
      <span class="info">
        <i class="fa fa-info-circle"></i> {{ $t('messages.limit', { limit: '1 - &infin;' }) }}
      </span>
      <a href="/games/auto-lotto" class="btn btn-primary">{{ $t('messages.playNow') }}</a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'game-space-lottery',
  data() {
    return {
      title: '',
      countdown: 0,
      lastedResult: '',
      resultDigits: [],
    };
  },
  filters: {
    roundOnly(value) {
      const string = value.split(' ');
      return string[string.length - 1];
    },
  },
  async created() {
    await this.getCurrentPeriod();
    const spaceLottoChannel = pusher.subscribe('presence-space-lotto')
    spaceLottoChannel.bind('start-new-round', ({ data }) => {
      const currentTime = data.currentTime;
      const endTime = new Date(data.close_date).valueOf();
      const duration = this.findDuration(currentTime, endTime);
      setTimeout(() => {
        this.title = data.period_title;
        this.resultDigits = [];
        this.countdown = Math.round(duration / 1000) - 10;
        this.startCounter();
      }, 10000);
    });
  },
  methods: {
    formatTime(value) {
      const minute = Math.floor(value / 60);
      const seconds = value - (minute * 60);
      return `${String(minute).length > 1 ? minute : `0${minute}`}:${String(seconds).length > 1 ? seconds : `0${seconds}`}`;
    },
    findDuration(start, end) {
      const currentTime = start;
      const endTime = end;
      const duration = end - start;
      return duration;
    },
    startCounter() {
      const interval = setInterval(() => {
        const secLeft = this.countdown - 1
        this.countdown = secLeft;
        if (this.countdown <= 0) {
          clearInterval(interval);
        }
      }, 1000)
    },
    async getCurrentPeriod() {
      const { data } = await window.axios.get('/space-lotto/current');
      if (data) {
        this.title = data.title;
        if (data.lastedResult) {
          const lastedResultStringToJson = JSON.parse(data.lastedResult);
          this.lastedResult = lastedResultStringToJson.first_win;
        }
        const currentTime = data.currentTime;
        const endTime = new Date(data.close_date).valueOf();
        const duration = this.findDuration(currentTime, endTime);
        this.countdown = Math.round(duration / 1000);
        this.startCounter();
      }
    }
  },
};
</script>
<style scoped>
  i.empty {
    width: 19px;
    height: 19px;
    display: block;
    margin: 0;
  }
</style>




// WEBPACK FOOTER //
// resources/assets/js/admin/pages/games/SpaceLotto.vue